module.exports = __webpack_public_path__ + "img/ds_hs.2f7490cb.png";